import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionProcessing.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import waitAnimation from "../animations/waitAnimation.json";
import { loginApi } from '../api/api';
import { useAppDispatch } from '../Store/hooks';
import { setUser } from '../Slices/userSlice';
import { motion,useAnimationControls } from 'framer-motion';
import BackgroundLayout from '../Components/BackgroundLayout';

const SubscriptionProcessing = () => {

     const location = useLocation();
    const [msisdn, setMsisdn] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [attemptCount, setAttemptCount] = useState(0);
    const dispatch=useAppDispatch();

        const variants = {
        hidden: {
            opacity: 0,
            scale: 0,
        },
        visible: {
            opacity: 1,
            scale: 1,
        },
    };

    const controls = useAnimationControls();

    useEffect(() => {
        controls.start("visible");
    }, []);

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            navigate("/");
        }
    }, [location]);

    useEffect(() => {
        let apiInterval = null as any;

        // if (!loading && msisdn && attemptCount < 100) {
        if (!loading && msisdn) {
            apiInterval = setInterval(() => {
                handleFormSubmission();
            }, 2000);
        }

        // if (attemptCount > 100) {
        //     toast.error("Something Went Wrong!");
        //     navigate("/login");
        // }

        return () => {
            if (apiInterval) {
                clearInterval(apiInterval);
            }
        };
    }, [msisdn, loading]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            await loginApi(msisdn)
                .then((res) => {
                    setLoading(false);
                    console.log("res---", res?.data?.result?.msisdn);
                    dispatch(setUser(res?.data?.result));
                    navigate("/home");
                    toast.success("Subscribed Successfully! Login...");
                })
                .catch((err) => {
                    setLoading(false);
                    setAttemptCount(prev => prev + 1);
                });
        } catch (error) {
            setLoading(false);
            setAttemptCount(prev => prev + 1);
            console.log(error, 'error--');
        }
    }

  return (
        <BackgroundLayout style={{padding:0}}>
            <motion.div
                layout
                variants={variants}
                initial="hidden"
                animate={controls}
                transition={{
                    type: "spring",
                    stiffness: 700,
                    damping: 30,
                }}
                className={classes.auth_modal}
            >
                <div className={classes.auth_sub_modal}>
                    <motion.div className={classes.form_modal}>
                        <img src="/assets/images/logo2.png" alt="uvmovie" className={classes.logo} />
                        {/* <p className={classes.title}>Subscribe Service</p> */}


                                    <div className={classes.container_2}>
                    <div className={classes.description}>
                        <h2 className={classes.title}>Subscription In Process</h2>
                        <ul className={classes.list}>
                            <li className={classes.text}>
                                Dear User, your subscription is in process!
                            </li>
                        </ul>

                        <div className={classes.animation_container}>
                            <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                        </div>

                        <p className={classes.text2}>
                            You will be auto redirected when successfully subscribed!
                        </p>
                    </div>
                </div>

                 

                    </motion.div>
                </div>
            </motion.div>

        </BackgroundLayout>
  )
}

export default SubscriptionProcessing